export const stepperMessages: { [key: string]: string[] } = {
  en: [
    'Application received.',
    'Payment in process.',
    'Payment confirmed.',
    'Policy sent.',
  ],
  es: [
    'Solicitud recibida.',
    'Pago en proceso.',
    'Pago confirmado.',
    'Póliza enviada.',
  ],
};
